"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyPromo = void 0;
exports.emptyPromo = {
    title: "",
    productId: "",
    photos: [],
};
//# sourceMappingURL=empty-promo.js.map